import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavigationHeader from '../../components/ui/NavigationHeader';
import CodePlayground from '../learn/CodePlayground';
import Icon from '../../components/AppIcon';

const CodePlaygroundPage = () => {
    const location = useLocation();
    // Check for predefined code/language passed from the interview report route
    const { code, language } = location.state || {};

    return (
        <div className="min-h-screen bg-white selection:bg-emerald-100 selection:text-emerald-900 relative">
            <NavigationHeader />

            <main className="pt-24 pb-12 px-6 sm:px-12 lg:px-24 max-w-[1400px] mx-auto min-h-screen flex flex-col">
                <div className="flex items-center justify-between mb-8">
                    <div>
                        <div className="flex items-center gap-3 mb-2">
                            <div className="p-2 rounded-xl bg-slate-900 text-white shadow-sm">
                                <Icon name="TerminalSquare" size={18} />
                            </div>
                            <h1 className="text-2xl font-black text-slate-900 tracking-tight">Code Sandbox</h1>
                        </div>
                        <p className="text-sm font-medium text-slate-500">
                            Experiment, optimize, and test code execution against our protected environment.
                        </p>
                    </div>
                </div>

                {/* Grow exactly to fill the visible height nicely */}
                <div className="flex-1 w-full relative">
                    <CodePlayground 
                        initialCode={code || '// Welcome to the Sandbox!\n// Write code here and add Custom Input to test specific edge cases.'} 
                        initialLanguage={language || 'javascript'} 
                        enableHistory={true}
                    />
                </div>
            </main>
        </div>
    );
};

export default CodePlaygroundPage;
